import * as yup from 'yup'

export const validationSchema = yup.object().shape({
  reportRecommendation: yup.string().max(500, 'Máximo 500 caracteres')
})
